// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bda03490","855":"6bb4a8ac"}[chunkId] + ".chunk.js";
};